var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sns/circle_facebook"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "vector",
    cx: 19.9998,
    cy: 20.2142,
    r: 18.3333,
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M38.3332 20.2142C38.3332 10.0891 30.125 1.88086 19.9998 1.88086C9.8747 1.88086 1.6665 10.0891 1.6665 20.2142C1.6665 28.8118 7.58597 36.0263 15.5712 38.0078V25.8169H11.7909V20.2142H15.5712V17.8001C15.5712 11.5601 18.3953 8.66786 24.5216 8.66786C25.6832 8.66786 27.6874 8.89593 28.5072 9.12326V14.2016C28.0746 14.1561 27.3229 14.1334 26.3894 14.1334C23.3834 14.1334 22.2218 15.2723 22.2218 18.2327V20.2142H28.2102L27.1814 25.8169H22.2218V38.4133C31.2998 37.317 38.3339 29.5877 38.3339 20.2142H38.3332Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M26.3269 27.2185L27.2501 22.2183H21.8765V20.4499C21.8765 17.8078 22.9189 16.7914 25.6162 16.7914C26.4539 16.7914 27.1284 16.8117 27.5166 16.8523V12.32C26.7809 12.1165 24.9825 11.9136 23.9402 11.9136C18.4429 11.9136 15.9088 14.4948 15.9088 20.0638V22.2183H12.5166V27.2185H15.9088V38.0985C17.1814 38.4127 18.5127 38.5802 19.8827 38.5802C20.5572 38.5802 21.2225 38.5429 21.8759 38.4644V27.2185H26.3269Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFacebookIcon);
export default __webpack_public_path__ + "static/media/login_facebook_icon.c968c18931113140add8d1aee2e3c610.svg";
export { ForwardRef as ReactComponent };